import React from 'react';
import { createUseStyles } from 'react-jss';

// This is shared between SSR and CSR to maintain consistency
const useStyles = createUseStyles({
  '@global': {
    // body reset - similar to previous wds-reset styles
    body: {
      '-webkit-font-smoothing': 'antialiased',
      fontSize: '16px',
      padding: 0,
      margin: 0,
      listStyle: 'none',
    },
    // temporarily disabled until we have visual diff tests to ensure it isn't breaking anything
    // html: {
    //   boxSizing: 'border-box',
    // },
    // '*, *:before, *:after': {
    //   boxSizing: 'inherit',
    // },
  },
});

export const GlobalStyleReset = (): React.ReactElement => {
  useStyles();
  return <></>;
};

export default GlobalStyleReset;
